import { FC } from "react";
import { Chip } from "@mui/material";
import { FilterItemNode, KeyValuePair } from "@/services/cloudchipr.api";
import { filterAvailableFieldsChecker } from "@/components/pages/common/filters-tree/utils/helpers/data-type-checkers/filterAvailableFieldsChecker";
import { getFilterValueDataTypeByOperator } from "@/components/pages/common/filters-tree/utils/helpers/data-type-checkers/getFilterValueDataTypeByOperator";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";
import { FilterTreeDisabledValueAutocomplete } from "@/components/pages/common/filters-tree/filters-disabled-view/components/FilterTreeDisabledValueAutocomplete";

interface FilterTreeDisabledValueProps {
  filter: FilterItemNode;
}

export const FilterTreeDisabledValue: FC<FilterTreeDisabledValueProps> = ({
  filter,
}) => {
  const { hasKey } = filterAvailableFieldsChecker(filter.type, filter.operator);
  const valueType = getFilterValueDataTypeByOperator(filter.operator);
  const filterValue = hasKey
    ? (filter.value as KeyValuePair)?.value
    : filter.value;

  const valueIsPrimitive = valueType === "string";

  if (valueIsPrimitive) {
    return (
      <Chip
        size="small"
        label={
          <TypographyWithTooltip
            variant="inherit"
            title={filterValue as string}
            maxWidth={150}
          />
        }
        variant="outlined"
      />
    );
  }

  return (
    <FilterTreeDisabledValueAutocomplete
      filterType={filter.type}
      provider={filter.filter_provider}
      filterValue={filterValue as string[]}
      filterKey={hasKey ? (filter.value as KeyValuePair).key : undefined}
    />
  );
};
